export default "{\n    \"label\": \"Vencido\"\n}\n"